import { render } from "./tabs.vue?vue&type=template&id=62cd05c2&scoped=true&ts=true"
import script from "./tabs.vue?vue&type=script&lang=ts"
export * from "./tabs.vue?vue&type=script&lang=ts"

import "./tabs.vue?vue&type=style&index=0&id=62cd05c2&scoped=true&lang=stylus"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cd05c2"]])

export default __exports__